import axios from "axios";

const rawBaseUrl = `${process.env.REACT_APP_SERVER_URL || ""}`.trim();
const isLocal8000 =
    /^(https?:\/\/)?(localhost|127\.0\.0\.1):8000\/?$/i.test(rawBaseUrl) ||
    rawBaseUrl.includes("localhost:8000") ||
    rawBaseUrl.includes("127.0.0.1:8000");
const baseURL = isLocal8000 ? "http://127.0.0.1:8001" : rawBaseUrl;

const axiosInstance = axios.create({
    baseURL,
    timeout: 300000,
    withCredentials: true,
});

// No Authorization header.
// Browser sends the session cookie automatically when withCredentials is true.
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            // optional: clear local UI state only
            localStorage.removeItem("username");
            localStorage.removeItem("email");
            localStorage.removeItem("role");
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
